function directToFix(
  flightState,
  fixName,
  liveAircraftPosition = null
) {
  if (!flightState?.route?.waypoints?.length) return flightState;

  // 🔎 Case-insensitive match
  const fixIndex = flightState.route.waypoints.findIndex(
    w =>
      w.name?.toUpperCase() === fixName.toUpperCase() ||
      w.identifier?.toUpperCase() === fixName.toUpperCase() ||
      w.id?.toUpperCase() === fixName.toUpperCase()
  );

  console.log("🧭 Fix index found:", fixIndex);

  if (fixIndex === -1) {
    console.warn("Fix not found in waypoints:", fixName);
    return flightState;
  }

  // 🔥 Save current route snapshot
  const previousRoute = JSON.parse(JSON.stringify(flightState.route));
  const amendedHistory = [
    ...(flightState.route.amendedHistory || []),
    previousRoute
  ];

  // 🔥 Trim waypoints
  const newWaypoints = flightState.route.waypoints.slice(fixIndex);
  console.log("✂️ Waypoints trimmed to:", newWaypoints.length);

  // 🔥 Find matching coordinate index safely
  let coordIndex = 0;

  const firstWaypoint = newWaypoints[0];

  if (firstWaypoint?.coordinates && Array.isArray(firstWaypoint.coordinates)) {
    const [lon, lat] = firstWaypoint.coordinates;

    const foundIndex = flightState.route.coords.findIndex(c =>
      Math.abs(c[0] - lon) < 0.0001 &&
      Math.abs(c[1] - lat) < 0.0001
    );

    console.log("🧭 Coord index found:", foundIndex);

    if (foundIndex !== -1) {
      coordIndex = foundIndex;
    }
  }

// =====================================
// ✈️ BUILD TRUE DIRECT-TO GEOMETRY
// Aircraft Position → Selected Fix → Remaining Route
// =====================================

const aircraftPosition =
  liveAircraftPosition ||
  flightState.aircraft?.position;

if (
  !aircraftPosition ||
  aircraftPosition.length !== 2
) {

  console.warn(
    "❌ Missing aircraft position"
  );

  return flightState;
}

// 🔥 Remaining route AFTER clicked fix
const remainingCoords =
  flightState.route.coords.slice(coordIndex + 1);

// 🔥 Build new operational route
const newCoords = [

  aircraftPosition,

  firstWaypoint.coordinates,

  ...remainingCoords
];

console.log(
  "✈️ Direct-To route rebuilt:",
  newCoords.length
);

  // 🔥 Recalculate distance
  const newDistanceNm = calculateRouteDistanceNm(newCoords);

  // 🔥 Recalculate timing
  const groundSpeed = flightState.aircraft?.groundSpeed || 1;
  const eteRemainingMinutes = (newDistanceNm / groundSpeed) * 60;

  // 🔥 Recalculate projected fuel
  const burnRate = flightState.fuel?.burnRatePerHour || 0;
  const hoursRemaining = newDistanceNm / groundSpeed;
  const projectedFuel =
    (flightState.fuel?.fuelRemaining || 0) -
    burnRate * hoursRemaining;

  return {
    ...flightState,

    meta: {
      ...flightState.meta,
      routeTextCurrent: `DCT ${fixName}`
    },

    route: {
      ...flightState.route,
      coords: newCoords,
      waypoints: newWaypoints,
      totalDistanceNm: newDistanceNm,
      distanceRemainingNm: newDistanceNm,
      amendedHistory
    },

    fuel: {
      ...flightState.fuel,
      projectedFuelAtDestination: projectedFuel
    },

    timing: {
      ...flightState.timing,
      eteRemainingMinutes
    },

    aircraft: {
      ...flightState.aircraft,
      currentLegIndex: 0
    }
  };
}

function calculateRouteDistanceNm(coords) {
  if (!coords || coords.length < 2) return 0;

  const toRad = d => (d * Math.PI) / 180;
  const R = 3440.065; // nautical miles

  let total = 0;

  for (let i = 0; i < coords.length - 1; i++) {
    const [lon1, lat1] = coords[i];
    const [lon2, lat2] = coords[i + 1];

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    total += R * c;
  }

  return total;
}


// ✅ Default export (fixes ESLint export error)
export default directToFix;